import { filter, map } from 'rxjs/operators';
import { LEGAL_DATA_SECURITY, WAITINGROOM_MULTIUSER_ROUTE } from '../../../routes';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { AuthStateProvider } from '../../auth/auth-state.provider';
import { Store } from '@ngrx/store';
import { AppState } from '../../../providers/store/app.state';
import { Observable, Subscription } from 'rxjs';
import { BrandingService } from '../../branding/providers/branding.service';
import { Profile, ProfileType } from '../../profile/store/profile.entity';
import { selectCurrentProfile } from '../../profile/store/profile.selector';
import { ProfileAcceptDataProcessAction } from '../../profile/store/profile.action';
import { RouterHelperService } from '../../utils/router-helper/router-helper.service';
import { AccessibilityService } from '../../../providers/accessibility/accessibility.service';
import { NgStyle, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-data-process-term',
    templateUrl: './data-process-term.component.html',
    styleUrls: ['./data-process-term.component.scss'],
    imports: [NgStyle, AsyncPipe, TranslatePipe]
})

export class DataProcessTermComponent implements OnInit, OnDestroy {
    public profileData: Profile;
    public isAllowToShowTerm: boolean;
    public backgroundImg$: Observable<{ backgroundImage: string }>;
    public dataSecurityLink = window.location.origin + LEGAL_DATA_SECURITY;
    private subscription: Subscription;

    constructor(
        private translate: TranslateService,
        private authProvider: AuthStateProvider,
        private router: RouterHelperService,
        private store: Store<AppState>,
        private brandingService: BrandingService,
        private accessibilityService: AccessibilityService) {
    }

    ngOnInit(): void {
        this.subscription = this.store.select(selectCurrentProfile).pipe(
            filter(e => e !== null && e !== undefined))
            .subscribe(profile => {
                if (profile.dataProcessTerm === true || profile.type !== ProfileType.PATIENT) {
                    this.router.navigate([WAITINGROOM_MULTIUSER_ROUTE]);
                }
                this.profileData = profile;
                this.isAllowToShowTerm = !this.profileData?.dataProcessTerm && this.profileData?.type === ProfileType.PATIENT;
            });

        this.backgroundImg$ = this.brandingService.getBrandingSettingsFromStore().pipe(
            map(settings => {
                const backgroundImg = settings.bgImage_patientLogin || '/assets/img/general/bg-login.jpg';
                return {backgroundImage: backgroundImg};
            }));

        // BFSG: Announce data process terms loading to screen readers
        this.translate.get('ACCESSIBILITY.SR_DATA_PROCESS_TERMS_LOADED').subscribe(message => {
            this.accessibilityService.announceToScreenReader(message, 'polite');
        });
    }

    public logout() {
        // BFSG: Announce logout action to screen readers
        this.translate.get('ACCESSIBILITY.SR_DECLINING_TERMS_LOGOUT').subscribe(message => {
            this.accessibilityService.announceToScreenReader(message, 'polite');
        });
        this.authProvider.logOut();
    }

    public acceptDataProcess() {
        // BFSG: Announce acceptance to screen readers
        this.translate.get('ACCESSIBILITY.SR_TERMS_ACCEPTED_PROCEEDING').subscribe(message => {
            this.accessibilityService.announceToScreenReader(message, 'polite');
        });
        this.store.dispatch(new ProfileAcceptDataProcessAction(this.profileData));
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
